import "./hooks"
// Import hooks type to enable auto-complete
import "vue-class-component/hooks"
import Vue from "vue"
import VueCookies from "vue-cookies"
import "./animations"
// Styles & Fonts
import "@/quasar"
import "@/styles/themes/gallagher.scss"
import "@/quasar-theme"
import {VueCommonFilters} from "@avantek/commons-js/format/VueCommonFilters"
import {cubes, measures} from "@/cube"
import * as am4core from "@amcharts/amcharts4/core"
import {icons} from "@/ui/icons"
import {formatMoney} from "@/utils/formatter"

Vue.use(VueCommonFilters)
Vue.use(VueCookies)

Vue.prototype.$cubes = cubes
Vue.prototype.$metrics = measures
Vue.prototype.$icons = icons

// FIXME remove after evaluation/buy license
am4core.options.commercialLicense = true
// am4core.options.autoDispose = true

// Override default format
const dateFilter = <(value: string, format: string) => string>Vue.filter("date")
const defaultDateFilter = (value: string, format = "dd/MM/yyyy") => dateFilter(value, format)
Vue.filter("date", defaultDateFilter)

Vue.filter("formatMoney", (value: number) => formatMoney(value))

const deCamelCase = (value: string) => value.replace(/[A-Z]/g, " $&").replace(/^./, toUppercase)
const toUppercase = (value: string) => value.toUpperCase()

Vue.filter("deCamelCase", deCamelCase)
